module.exports = __webpack_public_path__ + "img/qph2.a990595c.jpg";